import { RadioWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-radio-widget',
  templateUrl: './radio.widget.html'
})
export class MyRadioWidgetComponent extends RadioWidget {
  public data: any;

  readControl(schema, control) {
    if (schema.widget.id === 'sf-radio') {
      this.data = control.value;
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/radio/radio.widget.ts